import { RootActions } from '@/store/enums';
import { Store } from 'vuex';
import RootState from '@/store/rootState';

export class SpinnerPluginService {
  constructor(private store: Store<RootState>) {}

  public showSpinner(): void {
    this.store.dispatch(RootActions.ShowSpinner);
  }

  public removeSpinner(): void {
    this.store.dispatch(RootActions.RemoveSpinner);
  }
}
